import type { ClinicRow } from '@pa/api/admin'

const LABELS: Record<ClinicRow['displayStatus'], { text: string; className: string }> = {
  active: { text: 'Active', className: 'pill pill-active' },
  inactive: { text: 'Inactive', className: 'pill' },
  not_connected: { text: 'Not connected', className: 'pill pill-expired' },
}

/** S-02 / S-04 status: Active / Inactive / Not connected (UserFlows S-02). */
export function StatusPill({ status }: { status: ClinicRow['displayStatus'] }) {
  const { text, className } = LABELS[status]
  return <span className={className}>{text}</span>
}
